<template>
	<div class="video-container">
		<iframe
			:src="videoEmbedLink"
			frameborder="0"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
			allowfullscreen>
		</iframe>
	</div>
</template>

<script>

export default {

	name: 'YoutubeVideo',

	props: [
		"url"
	],
	data() {
		return {

		}
	},
	computed: {
		videoEmbedLink() {
			const code = this.extractYouTubeVideoCode(this.url)
			return (code) ? "https://www.youtube.com/embed/" + code : ""
		}
	},
	methods: {
		extractYouTubeVideoCode(url) {
			if (!url || url == "")
				return false

			const parsedURL = new URL(url)

			// 1. If video is in format "https://www.youtube.com/watch?v=<CODE>&ab_channel=<CHANNEL_NAME>"   (pulled from browser bar)
			if (parsedURL.hostname.endsWith('youtube.com') && parsedURL.pathname == '/watch') {
				console.log("got here", parsedURL)
				if (parsedURL.searchParams.has('v'))
					return parsedURL.searchParams.get('v')
			}

			// 2. If video is in format "https://youtu.be/<CODE>" (pulled from right-clicking on the video -> "Copy video URL")
			else if (parsedURL.hostname.endsWith('youtu.be'))
				return parsedURL.pathname.split('/')[1]

			return false
		}
	},
	created() {

	}
}
</script>

<style type="text/css" scoped>

.video-container {
	position: relative;
	width: 100%; /* Set your desired width here */
	height: 0;
	padding-bottom: 56.25%; /* 16:9 aspect ratio */
}

.video-container iframe {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}
</style>